/**
 * «Юниверситет» (28.09): экраны итога. Квест — «Пройдено/Почти», счёт зелёным или
 * оранжевым, порог — pass_percent квеста или пакета (в макете были зашиты 60 %).
 * Вопросы дня — свой итог «верных из N, +XP» (в макете брался итог квеста с «нужно 60 %»).
 */
import { useEffect, useRef } from "react";
import css from "./run.module.css";
import ui from "./uni.module.css";

function useFocusFirst() {
  const ref = useRef<HTMLButtonElement>(null);
  useEffect(() => { ref.current?.focus(); }, []);
  return ref;
}

interface QuestResultProps {
  title: string;
  got: number;
  n: number;
  pct: number;
  passed: boolean;
  onBack: () => void;
  onRetry: () => void;
}

export function QuestResult({ title, got, n, pct, passed, onBack, onRetry }: QuestResultProps) {
  const first = useFocusFirst();
  return (
    <div className={css.result} data-fb="result" data-fb-name="Итог квеста">
      <h2 className={ui.h2}>{passed ? "Пройдено" : "Почти"}</h2>
      <div className={ui.sub}>{title}</div>
      <p className={`${css.score} ${passed ? css.scoreOk : css.scoreBad}`}>{got} / {n}</p>
      <p className={css.resText}>
        {passed ? "Задание засчитано." : `Нужно ${pct}% правильных. Загляни в базу знаний и попробуй ещё раз.`}
      </p>
      <div className={ui.acts}>
        <button ref={first} type="button" className={ui.btn} onClick={onBack}>К комнате</button>
        {!passed ? <button type="button" className={`${ui.btn} ${ui.ghost}`} onClick={onRetry}>Ещё раз</button> : null}
      </div>
    </div>
  );
}

export function DailyResult({ right, n, xpPer, onDone }: { right: number; n: number; xpPer: number; onDone: () => void }) {
  const first = useFocusFirst();
  return (
    <div className={css.result} data-fb="result" data-fb-name="Итог вопросов дня">
      <h2 className={ui.h2}>Вопросы дня</h2>
      <div className={ui.sub}>На сегодня всё. Завтра будут новые.</div>
      <p className={`${css.score} ${right ? css.scoreOk : css.scoreBad}`}>{right} / {n}</p>
      <p className={css.resText}>{right ? `Верных ${right} из ${n}, +${right * xpPer} XP.` : "Сегодня без опыта — завтра получится."}</p>
      <div className={ui.acts}>
        <button ref={first} type="button" className={ui.btn} onClick={onDone}>Готово</button>
      </div>
    </div>
  );
}
